import { EffortInfo } from "./effort.model"
import { ProjectInfo } from "./project.model"

export class EffortPlanInfo {
  EffortPlanId: number
  EffortGroupId: number
  EffortPlanProjectRole: string
  EffortPlanRole: string
  EffortPlanCreateDate: string
  EffortPlanCreateBy: string
  EffortPlanCreateByDisplay: string
  EffortPlanUpdateDate: string
  EffortPlanUpdateBy: string
  EffortPlanUpdateByDisplay: string
  EffortPlanFlagActive: string
  EffortPlanFlagDelete: string

  ProjectSaleCode: string
  ProjectSaleName: string
  ProjectType: string
  EffortGroupName: string
  EffortPlanEmpName: string
  EffortPlanEmpCode: string
  EffortPlanRoleName: string
  CompanyName: string
  EffortPlanTotalMan: number
  SearchAsOfDate: string

  ETC: number

  ListEffort: EffortInfo[]
  ListProject: ProjectInfo[]
}

export class EffortPlanViewInfo {

  DeletePlanGroupId: number
  ListEffortPlan: EffortPlanInfo[]
}

export class EffortPlanTransferInfo {

  CurrentEffortPlan: EffortPlanInfo
  ToEffortPlan: EffortPlanInfo

}
